import React from 'react';

/** Janela de mensagem/confirmação (equivalente ao Alert.alert do React Native). */
export function Aviso({ aviso, onFechar }) {
  if (!aviso) return null;

  const fechar = () => onFechar && onFechar();
  const confirmar = () => {
    fechar();
    if (aviso.onConfirmar) aviso.onConfirmar();
  };

  return (
    <div className="oficina-modal-fundo" role="presentation" onClick={fechar}>
      <div className="oficina-modal" role="alertdialog" aria-modal="true" aria-labelledby="oficina-modal-titulo" onClick={(e) => e.stopPropagation()}>
        <h2 id="oficina-modal-titulo">{aviso.titulo}</h2>
        <p>{aviso.mensagem}</p>
        <div className="oficina-modal-acoes">
          {aviso.onConfirmar ? (
            <>
              <button type="button" className="oficina-botao oficina-botao-texto" onClick={fechar}>Cancelar</button>
              <button type="button" className={`oficina-botao ${aviso.destrutivo ? 'oficina-botao-perigo' : 'oficina-botao-primario'}`} onClick={confirmar}>
                {aviso.textoConfirmar || 'OK'}
              </button>
            </>
          ) : (
            <button type="button" className="oficina-botao oficina-botao-primario" onClick={fechar}>OK</button>
          )}
        </div>
      </div>
    </div>
  );
}

export function Carregando({ texto }) {
  return (
    <div className="oficina-carregando" role="status">
      <span className="oficina-spinner" aria-hidden="true" />
      {texto ? <span>{texto}</span> : null}
    </div>
  );
}
